var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aspect-ratio flex minh-100 minw-100"},[_c('div',{staticClass:"aspect-ratio__sizer",style:({ paddingBottom: _vm.aspect_ratio_percentage })}),_c('div',{staticClass:"aspect-ratio__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }